import React from "react";
import '../App.css';
import Navbar from "../Navbar";

function zHint6(){
    return (
        <>
        <Navbar/>
        <div class="container pt-5">
        <div class="row">
            <div class="col-lg-9">
                <h2>Why did you collect this item?</h2>
                <p>This item contains nothing, do not believe everything you see. Try again.</p>
            </div>
        </div>
    </div>

        </>
);
};

export default zHint6;